import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';
import React from 'react';
var _excluded = ["checkClassName", "children", "id", "inputClassName", "inputRef", "isChecked", "isDisabled", "key", "labelClassName", "labelAction", "name", "onChange", "onClick", "type", "value"];
/**
 * Common Checkbox/Radio component
 *
 * @param {any} {
 *   @param {string}  checkClassName        classes applied to <Check> component
 *   @param {any}     children              child elements of <Check.Input> component
 *   @param {string}  id                    id selector of <Check.Input> and for of corresponding <Check.Label>
 *   @param {string}  inputClassName        classes applied to <Check.Input> component
 *   @param {string}  inputRef              ref of <Check.Input> component
 *   @param {bool}    isChecked             is checkbox/radio checked
 *   @param {boolean} isDisabled            is checkbox/radio disabled
 *   @param {string}  key                   key of parent <Check> component
 *   @param {string}  labelClassName        classes applied to <Check.Label> component
 *   @param {string}  labelAction           data-action attribute of <Check.Label> component
 *   @param {string}  name                  name of <Check.Input> component
 *   @param {any}     onClick               external handler function
 *   @param {string}  type                  type of input ('checkbox' | 'radio')
 *   @param {string}  value                 value of <Check.Input> component
 * }
 * @returns {JSX.Element}
 */

var Checkbox = function Checkbox() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$checkClassName = _ref.checkClassName,
      checkClassName = _ref$checkClassName === void 0 ? '' : _ref$checkClassName,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      id = _ref.id,
      _ref$inputClassName = _ref.inputClassName,
      inputClassName = _ref$inputClassName === void 0 ? '' : _ref$inputClassName,
      inputRef = _ref.inputRef,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      key = _ref.key,
      _ref$labelClassName = _ref.labelClassName,
      labelClassName = _ref$labelClassName === void 0 ? '' : _ref$labelClassName,
      labelAction = _ref.labelAction,
      name = _ref.name,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Form.Check, {
    className: checkClassName,
    key: key
  }, /*#__PURE__*/React.createElement(Form.Check.Label, {
    className: labelClassName,
    "data-action": labelAction,
    htmlFor: id
  }, /*#__PURE__*/React.createElement(Form.Check.Input, _extends({}, props, {
    checked: isChecked,
    className: inputClassName,
    disabled: isDisabled,
    id: id,
    ref: inputRef,
    name: name,
    onChange: onChange,
    onClick: onClick,
    type: type,
    value: value
  })), /*#__PURE__*/React.createElement("i", {
    className: "input-helper"
  }), children));
};

Checkbox.displayName = "Checkbox";
Checkbox.propTypes = {
  checkClassName: PropTypes.string,
  children: PropTypes.any,
  id: PropTypes.string,
  inputClassName: PropTypes.string,
  inputRef: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  key: PropTypes.string,
  labelClassName: PropTypes.string,
  labelAction: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string
};
export { Checkbox };